<template>
  <div class="page-content znjcIndex"   style="min-height: 90vh;" v-loading="loading">
    <div class="startTitle" style="overflow: hidden;">
      <el-col :span="1.5">
        <div style="float: left;margin-right: 10px;margin-top: 6px;">微体检</div>
        </el-col>

          <el-col :span="1.5">
           <el-button type="primary" size="mini" @click="xiazaiMs" icon="el-icon-download">下载微体检模板</el-button>
          </el-col>
           <el-col :span="1.5">
          <el-upload
            class="upload-demo"
            action = 'starin'
            :before-upload="UploadImage2"
            accept = ".xls"
            >

            <el-button style='margin-left:5px;' size="mini" type="primary" icon="el-icon-upload2">点击上传微体检模板</el-button>
          </el-upload>
          </el-col>
    </div>
    <el-row style="clear:both;" >
      <el-col :span="5" class="znjcIndexbox" v-for="(item,index ) in znjcList" :key="index">
        <div class="itemBox" @click="toPage(item.img, item.name, item.fucationType, item.dataString,item.unit)">
          <div class="pad20">
            <h4>{{item.name}}</h4>
            <div class="numberUnit">
              <h2 v-if="item.dataString != null">{{item.dataString}}<span style="font-size: 13px;color: #666;font-weight:initial;">{{item.unit}}</span></h2>
              <h2 v-else>--</h2>
             <!--  <span v-if="item.dataString != null">{{splitNumAndString(item.dataString).unit}}</span> -->
            </div>
            <span class="time" v-if="item.createTime!=null">监测时间 {{item.createTime}}</span>
            <span class="time" v-else>监测时间 --</span>
          </div>
          <img :src="item.img" alt="">
        </div>
      </el-col>
    </el-row>
<!--  -->
          <el-dialog :visible.sync="open" width="1000px" :show-close="false" style="line-height:1px; text-align:center; margin-top:0; padding-top:0;">

            <img class='codewrapImg' src='@/assets/images/app_coder2.png'/>
            <div class='codewrapdiv' >为了您更快捷全面的获取健康数据及更便捷的查看健康数据报告</div>
            <div class='codewrapdiv' >请您使用吾征AI健康APP或微信公众号体验健康服务</div>
            <div class='codewrapdiv2'>（扫描下方二维码下载安装APP或关注吾征AI微信公众号）</div>
            <div style='margin-bottom: 30px;'>
                <div class="codewrap" >
                  <img src="@/assets/images/app_coder.png">
                  <p>吾征AI健康APP</p>
                  <p>扫码下载</p>
                </div>
                <div class="codewrap">
                  <img src="@/assets/images/weixin_coder.png">
                  <p>吾征AI公众号</p>
                  <p>扫码关注</p>
                </div>
            </div>
        <!-- 关注公众号 -->
        <div id="alertwarp">
          <div id="alertmask"></div>
          <div id="alertwx">
          </div>
        </div>
      </el-dialog>
  </div>
</template>

<script>
import '@/assets/css/backcommon.css'
import Cookies from 'js-cookie'
import baseAPI from "@/api/baseAPI";
import { userDataReport , exportwtj , ExecutorFlies} from "@/api/dataReport"
import { Message } from 'element-ui'
export default {
  name: "znjcIndex",
  data () {
    return {
      loading: true,
      open: false,
      userId: "",
      defaultHeight: {
        height: ""
      },
      znjcList: []
    }
  },
  components: {},
  beforeMount () {
    this.userId = this.$store.state.user.userId;
    if (this.userId === "") {
      console.log(Cookies.get("userInfo"));
      this.userId = JSON.parse(Cookies.get("userInfo"))["userId"];
    }
  },
  mounted () {
    //页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
    this.userDataReport()
  },
  methods: {
    //提交微体检模板
     UploadImage2(param) {
      var _this = this;
      const formData = new FormData();

      //ExecutorFlie
      formData.append("monitoringExcelTemplateFile", param);
      formData.append("userId", '0');
        ExecutorFlies(formData).then(response => {

              _this.znjcList = null;
              _this.getHeight();
              _this.userDataReport()
              _this.$message({
              showClose: true,
              type: 'success',
              message: response.data.data.importResult,
              offset:130
              });


            }).catch((err) => {
               console.log(err)
                  // this.$message.error('请使用数据模板填写');
                });

    },
    /*下载微体检模板表格*/
    xiazaiMs(){
      let _this = this;
      var mywin = window.open('','_self');
      // console.log(process.env.VUE_APP_BASE_API);
            exportwtj().then(response => {

                  mywin.location.href = response.data.data.filePath;
                    _this.$message.success('下载模板成功');
                });
//  mywin.location.href = "https://ftp.infobigdata.com/userImportTemplate.xls"
    },
    // 循环value进行值和单位分割
    splitNumAndString (val) {
      var re = /^[0-9]+.?[0-9]*$/; //判断字符串是否为数字 //判断正整数 /^[1-9]+[0-9]*]*$/
      for (var i = val.length - 1; i > 0; i--) {
        if (re.test(val.charAt(i))) {
          var value = val.substring(0, i + 1);
          var unit = val.substring(i + 1, val.length);
          var param = { "value": value, "unit": unit };
          return param;
        }
      };
    },
    //定义方法，获取高度减去头尾
    getHeight () {
      this.defaultHeight.height = window.innerHeight - 105 + "px";
    },
    //初始
    userDataReport () {
      this.loading = true;

      userDataReport(this.userId).then(res => {
        var data = res.data;
        if (data.code === 200) {
          this.znjcList = data.data;
          this.loading = false;
        }
      })
    },
    // 判断用户是否进行过改项测量，没有的话进行提示
    toPage (img, name, id, value,unit ) {
     /* this.open = true;*/
      if (value == null) {
        Message({
          message: '您还没有进行测量！',
          type: 'warning',
          duration: 5 * 1000
        })
        return;
      }
      this.$router.push({
        path: '/personCenter/znjcIndex/znjcTable',
        query: {
          img,
          name,
          id,
          unit
        }
      })

    }
  },
}
</script>

<style >
.el-dialog__body{
  padding-top: 0;
}
.codewrapImg{

  width: 128px;
  height: 128px;
  margin-bottom: 50px;
}
.codewrapdiv{
  height: 15px;
  color:#000000;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
}
.codewrapdiv2{
  height: 15px;
  color:#666;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 55px;
}
.memberCenter .el-dialog__header{
  border:none;
}
.codewrap {
  display: inline-block;
  width: 100px;
  margin-right:70px;
  margin-left:70px;
  text-align: center;
}
.codewrap img {
  padding-bottom: 10px;
  /* margin-top: 40px; */
}
.codewrap p {
  width: 100%;
  height: 22px;
  line-height: 22px;
   /* margin-bottom: 20px; */
}
.znjcIndex .znjcIndexbox {
  /*border: 1px solid red;*/
  height: 130px;
  cursor: pointer;
  border-radius: 8px;
  margin-left: 18px;
  margin-top: 20px;
  background: #fff;
  border: 1px solid #f1f1f1;
  -webkit-transition: all 0.5s ease;
  transition: all 0.5s ease;
}
.znjcIndex .znjcIndexbox:hover {
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.znjcIndex .znjcIndexbox .itemBox {
  position: relative;
}
.znjcIndex .znjcIndexbox .itemBox h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: rgba(101, 101, 101, 1);
  padding-bottom: 10px;
}
.znjcIndex .znjcIndexbox .itemBox .numberUnit h2 {
/*  margin: 0;
  font-size: 20px;
  font-weight: 800;
  color: rgba(51, 51, 51, 1);
  display: inline-block;
  padding-bottom: 10px;*/

      margin: 0;
    font-size: 20px;
    line-height: 40px;
    font-weight: 800;
    color: rgba(51, 51, 51, 1);
    display: inline-block;
    padding-bottom: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    width: 71%;
}
.znjcIndex .znjcIndexbox .itemBox .pad20 {
  padding: 18px;
}
.znjcIndex .znjcIndexbox .itemBox .numberUnit span {
  margin-left: 10px;
  display: inline-block;
  font-size: 16px;
  font-weight: 500;
  color: rgba(153, 153, 153, 1);
}
.znjcIndex .znjcIndexbox .itemBox span.time {
  font-size: 13px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}
.znjcIndex .znjcIndexbox .itemBox img {
  width: 50px;
  height: 50px;
  display: block;
  position: absolute;
  right: 15px;
  top: 15px;
}
.el-col-6 {
  width: 23%;
}
</style>



// WEBPACK FOOTER //
// src/views/personCenter/znjcIndex.vue